var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-main"},[_c('el-steps',{attrs:{"finish-status":"success","process-status":"finish","active":_vm.activeIndex,"align-center":""}},_vm._l((_vm.selfList),function(item,index){return _c('el-step',{key:index,attrs:{"title":item.key,"description":item.desStr}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }